<template>
  <div>
    <template v-for="item in propertiesLocal">
      <template v-if="!isSelectable(item)">
        <v-select
          :menu-props="{ bottom: true, offsetY: true }"
          :label="`${item.title}`"
          :key="item.id"
          v-model="item.value"
          v-if="isBoolean(item.typeSpec)"
          item-value="id"
          item-text="name"
          :data-test="item.title"
          :items="[
            { id: true, name: 'true' },
            { id: false, name: 'false' },
            { id: null, name: 'null' }
          ]"
          class="pb-4"
        >
          <template v-slot:item="{ item: i }">
            <div :data-test-select-value="`${item.title}:${i.name}`">
              {{ i.name }}
            </div>
          </template>
        </v-select>
        <code-editor
          :key="item.id"
          v-model="item.value"
          @is-error="isCodeError = $event"
          v-else-if="isJson(item.typeId)"
          :code="JSON.stringify(item.value)"
        ></code-editor>
        <template v-else>
          <v-text-field
            :data-test="item.title"
            v-if="isNumber(item.typeSpec)"
            :key="item.id"
            type="number"
            :label="item.argument"
            clearable
            v-model.number="item.value"
          ></v-text-field>
          <v-text-field
            :data-test="item.title"
            v-else
            :key="item.id"
            :label="item.argument"
            clearable
            v-model="item.value"
          ></v-text-field>
        </template>
      </template>
      <template v-else>
        <v-select
          :menu-props="{ bottom: true, offsetY: true }"
          :data-test="item.title"
          :key="item.id"
          v-if="item.valueSet && item.valueSet.component === 'select'"
          v-model="item.value"
          item-value="key"
          class="pb-4"
          item-text="title"
          :items="item.valueSet.list"
        >
          <template v-slot:item="{ item: i }">
            <div :data-test-select-value="`${item.title}:${i.title}`">
              {{ i.title }}
            </div>
          </template>
        </v-select>
        <v-text-field
          :data-test="item.title"
          :key="item.id"
          v-else-if="item.valueSet"
          v-model="item.value"
          class="pb-4"
        ></v-text-field>
        <v-text-field
          :data-test="item.title"
          :key="item.id"
          v-if="item.valueRange"
          v-model.number="item.value"
          class="pb-4"
          :max="item.valueRange.max"
          :min="item.valueRange.min"
          type="number"
        ></v-text-field>
      </template>
    </template>
  </div>
</template>

<script>
import CodeEditor from '@/components/app-entity/modals/FullscreenCode.vue';
import { onMounted, ref, watch } from '@vue/composition-api';
import cloneDeep from 'lodash.clonedeep';
import { isBoolean, isJson, isNumber } from '@/utils/getCurrentType';

export default {
  name: 'ControlParameterField',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    properties: {
      type: Array,
      default: () => []
    }
  },
  components: { CodeEditor },
  setup(props, { emit }) {
    const propertiesLocal = ref([]);
    const isCodeError = ref(false);

    watch(
      () => props.properties,
      () => {
        // if (props.value)
        // propertiesLocal.value = cloneDeep(props.properties);
        // propertiesLocal.value.forEach(itemLocal => {
        //   props.value.forEach(itemValue => {
        //     if (itemLocal.argument === itemLocal)
        //   })
        // })
      },
      {
        immediate: true
      }
    );

    watch(
      () => propertiesLocal.value,
      () => {
        emit(
          'input',
          propertiesLocal.value.map(item => ({ [item.argument]: item.value }))
        );
      },
      {
        deep: true
      }
    );

    const isSelectable = item => {
      if (!item.valueSet && !item.valueRange) {
        return false;
      } else {
        return (
          Object.keys(item.valueSet).length &&
          Object.keys(item.valueRange).length
        );
      }
    };

    onMounted(() => {
      propertiesLocal.value = cloneDeep(props.properties);
    });

    return {
      isCodeError,
      propertiesLocal,
      isSelectable,
      isJson,
      isBoolean,
      isNumber
    };
  }
};
</script>
